import { createFileRoute, redirect } from "@tanstack/react-router";
import { Paper, Title, Box, Text } from "@mantine/core";
import { LoginForm } from "@/components/auth";
import { authApi } from "@/api/client";

export const Route = createFileRoute("/login")({
  beforeLoad: async () => {
    try {
      await authApi.me();
      throw redirect({ to: "/" });
    } catch {
      // Not logged in, continue to login page
    }
  },
  component: LoginPage,
});

function LoginPage() {
  return (
    <Box
      mih="100vh"
      bg="#1a1a2e"
      style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "1rem" }}
    >
      <Paper p="xl" radius="md" maw={400} w="100%" withBorder style={{ borderColor: "#0f3460" }}>
        <Title order={2} ta="center" mb="xl">
          <Text span c="primary">
            Qasa
          </Text>{" "}
          Notifier
        </Title>
        <LoginForm />
      </Paper>
    </Box>
  );
}
